// extracted by mini-css-extract-plugin
module.exports = {"error":"NotFound_error__31Vmq"};